import moment from "moment";
import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import TableFooter from "../../../../components/TableFooter.jsx";
import genericTranslations from "../../../../utils/genericTranslations.js";
import {
  isLoadingMalfunctions,
  selectMalfunctions,
  selectVehicleNumber,
} from "../../selectors";

const styles = {
  main: { backgroundColor: "#FAFAFA" },
  fold: {
    display: "block",
    flexDirection: "column",
    cursor: "pointer",
  },
  description: { maxWidth: "360px" },
  long: { padding: "12px", maxWidth: "360px", backgroundColor: "#F3F9FE" },
  footerWrapper: { display: "flex" },
  footerInnerWrapperRight: { textAlign: "right" },
  footerAddButton: { margin: "20px 0" },
};

const messages = defineMessages({
  vehicle: {
    id: "modules.Malfunctions.components.MalfunctionsList.vehicle",
    description: "Vehicle Label",
    defaultMessage: "Vehicle-number",
  },
  workOrderCode: {
    id: "modules.Malfunctions.components.MalfunctionsList.workOrderCode",
    description: "Workorder-code Label",
    defaultMessage: "Workorder-code",
  },
  description: {
    id: "modules.Malfunctions.components.CategoriesList.description",
    description: "Description",
    defaultMessage: "Description",
  },
  workOrderDate: {
    id: "modules.Malfunctions.components.MalfunctionsList.workOrderDate",
    description: "Workorder-date Label",
    defaultMessage: "Workorder-date",
  },
  vehicleNumber: {
    id: "modules.Malfunctions.components.MalfunctionsList.vehicleNumber",
    description: "Vehicle number does not exist Label",
    defaultMessage:
      "This vehicle-number doesn't exists or doesn't have pending workorders",
  },
});

const MalfunctionsList = () => {
  const intl = useIntl();

  const [showExtraInfo, setShowExtraInfo] = useState(false);
  const [workCode, setWorkCode] = useState();

  const malfunctions = useSelector(selectMalfunctions);
  const vehicleNumber = useSelector(selectVehicleNumber);
  const isLoading = useSelector(isLoadingMalfunctions);

  const onClickHandler = (row) => {
    setShowExtraInfo((prev) => !prev);
    setWorkCode(row.workOrderCode);
  };

  const mapMalfunctionToTableRow = (row) => (
    <tr key={`malfunction-${row.workOrderCode}`}>
      <td>{row.workOrderCode}</td>
      <td onClick={() => onClickHandler(row)} style={styles.fold}>
        <p style={styles.description}>{row.failureDescription}</p>
        {showExtraInfo && workCode === row.workOrderCode && (
          <p style={styles.long}>{row.workOrderDescription}</p>
        )}
      </td>
      <td>{moment(row.createdAt).format("DD MMM YYYY")}</td>
      <td>{row.statusDescription}</td>
    </tr>
  );

  return (
    <div>
      {isLoading && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.loadingInProgress)}
        </span>
      )}

      {!isLoading &&
        (!malfunctions || malfunctions.length === 0) &&
        vehicleNumber && (
          <span className="align-middle">
            {intl.formatMessage(messages.vehicleNumber)}
          </span>
        )}

      {!isLoading && malfunctions && malfunctions.length > 0 && (
        <div>
          <h2>
            {intl.formatMessage(messages.vehicle)} {vehicleNumber}
          </h2>
          <Table responsive>
            <thead>
              <tr>
                <td>{intl.formatMessage(messages.workOrderCode)}</td>
                <td>{intl.formatMessage(messages.description)}</td>
                <td>{intl.formatMessage(messages.workOrderDate)}</td>
                <td>Status</td>
              </tr>
            </thead>
            <tbody>{malfunctions.map(mapMalfunctionToTableRow)}</tbody>
          </Table>
        </div>
      )}

      {vehicleNumber && (
        <TableFooter
          actionPath={`/malfunctions/pending-malfunctions/add/${vehicleNumber}`}
        />
      )}
    </div>
  );
};

export default MalfunctionsList;
